// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53631d33","491":"c1de7daa"}[chunkId] + ".chunk.js";
};